import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import Testimonials from "../components/Testimonials";
import WhyMe from "../components/WhyMe";
import Faq from "../components/Faq";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import MobileStickyCta from "../components/MobileStickyCta";

const Home = () => {
  useEffect(() => {
    document.title =
      "Jan Kowalski · Agent ubezpieczeniowy w Bieszczadach — 13 lat doświadczenia";
    const desc =
      "Lokalny pośrednik ubezpieczeniowy z 13-letnim doświadczeniem. OC, AC, ubezpieczenia na życie, dom i firmę. Obsługa całych Bieszczad i Podkarpacia.";
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", desc);

    // Schema.org LocalBusiness / InsuranceAgency
    const existing = document.getElementById("ld-json-business");
    if (existing) existing.remove();
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "ld-json-business";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "InsuranceAgency",
      name: "Jan Kowalski · Ubezpieczenia",
      description: desc,
      areaServed: ["Bieszczady", "Podkarpacie"],
      telephone: "+48669255184",
      email: "kontakt@agentbieszczady.pl",
      foundingDate: `${new Date().getFullYear() - 13}`,
      address: {
        "@type": "PostalAddress",
        streetAddress: "plac Konstytucji 3 Maja 7",
        postalCode: "38-600",
        addressLocality: "Lesko",
        addressCountry: "PL",
      },
      openingHoursSpecification: [
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          opens: "08:00",
          closes: "16:00",
        },
      ],
    });
    document.head.appendChild(script);
  }, []);

  return (
    <div data-testid="home-page" className="min-h-screen bg-cream">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Testimonials />
        <WhyMe />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <MobileStickyCta />
    </div>
  );
};

export default Home;
